import type {DigestType, Frequency} from './consts';

export type ErrorDetails = {
    message: string;
    stack: string;
    componentStack: string;
};

export type DigestResponse = {
    htmlContent: string | null | undefined;
    inputJson: string;
    error: string | null | undefined;
    errorDetails: ErrorDetails | null | undefined;
};

export type SendEmailResponse = {
    success: boolean;
    error: string | null | undefined;
};

export function fetchDigest(
    digestType: DigestType,
    frequency: Frequency,
    userId: string
): Promise<DigestResponse> {
    return fetch(
        `email-digest/get-digest?digestType=${digestType}&frequency=${frequency}&userId=${userId}`
    )
        .then((response) => {
            if (!response.ok) {
                throw new Error('Failed to fetch digest');
            }

            return response.text();
        })
        .then((text) => {
            const responseJson = JSON.parse(text);

            return {
                htmlContent: responseJson.htmlContent || null,
                inputJson: responseJson.inputJson,
                error: responseJson.error || null,
                errorDetails: responseJson.errorDetails || null,
            };
        });
}

export function sendTestEmail(
    digestType: DigestType,
    frequency: Frequency,
    userId: string,
    testEmail: string
): Promise<SendEmailResponse> {
    return fetch(
        `email-digest/send-test-email?digestType=${digestType}&frequency=${frequency}&userId=${userId}&testEmail=${encodeURIComponent(
            testEmail
        )}`
    )
        .then((response) => {
            if (!response.ok) {
                throw new Error('Failed to send test email');
            }

            return response.json();
        })
        .then((responseJson) => {
            return {
                success: responseJson.success || false,
                error: responseJson.error || null,
            };
        });
}

export function sendDigestViaGearman(
    digestType: DigestType,
    userId: string
): Promise<SendEmailResponse> {
    return fetch(`email-digest/send-digest-via-gearman?digestType=${digestType}&userId=${userId}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error('Failed to send digest');
            }

            return response.json();
        })
        .then((responseJson) => {
            return {
                success: responseJson.success || false,
                error: responseJson.error || null,
            };
        });
}
